<template>
    <div class="modal-card" ref="element">
        <header class="modal-card-head">
            <p class="modal-card-title">{{ editEnabled ? "Edit Questionnaire" : "Add Questionnaire" }}</p>
        </header>
        <section class="modal-card-body">
            <b-field label="Questionnaire Name:">
                <b-input type="text" v-model="name" placeholder="Questionnaire Name"
                    :disabled="role === 'viewer'"></b-input>
            </b-field>
            <b-field v-if="bQuestionnaireError" style="color: red">
                Please enter a name.
            </b-field>
            <hr/>
            <p style="margin-top:-10px; margin-bottom: 10px">Questionnaire Questions:</p>
            <b-table :mobile-cards="false" :data="tableData.length > 0 ? tableData : []" striped>

                <template slot-scope="props">
                    <b-table-column field="name" label="Question" centered>
                        {{ props.row.text }}
                    </b-table-column>
                    <b-table-column label="Edit/Remove" centered>
                        <b-button type="is-info" icon-left="edit" @click="editQuestionModal(props.row.id)"></b-button>
                        <b-button :disabled="role === 'viewer'" type="is-danger" icon-left="trash"
                            @click="confirmRemoveQuestion(props.row.id, props.row.text)"></b-button>
                    </b-table-column>
                </template>

                <template slot="empty">
                    <section class="section">
                        <div class="content has-text-grey has-text-centered">
                            <p>No questions to display.</p>
                        </div>
                    </section>
                </template>
            </b-table>
        </section>
        <footer class="modal-card-foot" style="background-color:white;border-radius:0px">
            <b-button type="is-success" icon-left="plus" @click="addQuestionModal" :disabled="role === 'viewer'">Add
                question</b-button>
            <p><b>No. of questions: {{ Object.keys(questions).length }}</b></p>
        </footer>
        <footer class="modal-card-foot">
            <b-button type="is-info" @click="saveQuestionnaire" v-if="editEnabled"
                :disabled="role === 'viewer'">Submit</b-button>
            <b-button type="is-info" icon-left="plus" @click="addQuestionnaire" v-else :disabled="role === 'viewer'">Add
                new
                questionnaire</b-button>
            <b-button type="is-light" @click="closeModal()">Cancel</b-button>
        </footer>
    </div>
</template>

<script>
import QuestionAddEdit from '@/components/questionnaires/QuestionAddEdit'

export default {
  name: 'QuestionnaireAddEdit',
  props: ['editEnabled', 'propId', 'propParentFn'],
  data: () => {
    return {
      editStaticQuestionnaireRef: {},
      name: '',
      questions: {},
      questionnaireId: '',
      tableData: [],
      bQuestionnaireError: false
    }
  },
  computed: {
    questionnaires () {
      return this.$store.state.questionnaires
    },
    workspaceId () {
      return this.$store.state.workspaceId
    },
    role () {
      return this.$store.state.role
    },
    userId () {
      return this.$store.state.uid
    }
  },
  mounted: function () {
    if (this.editEnabled) {
      let id = this.propId
      this.editStaticQuestionnaireRef = Object.assign({}, this.questionnaires[id])
      this.name = this.editStaticQuestionnaireRef.name
      this.globalLogger(this.editStaticQuestionnaireRef, 'REF')
      this.questionnaireId = id
      this.questions = {}
      let questionsRef = this.editStaticQuestionnaireRef.questions
      if (questionsRef) {
        for (let question in questionsRef) {
          this.questions[question] = questionsRef[question]
        }
      }
      for (let qId in this.questions) {
        this.tableData.push({ id: qId, ...this.questions[qId] })
      }
    }
  },
  methods: {
    refreshQuestionsTable () {
      this.tableData = []
      for (let qId in this.questions) {
        this.tableData.push({ id: qId, ...this.questions[qId] })
      }
    },
    addQuestionModal () {
      this.$buefy.modal.open({
        parent: this,
        component: QuestionAddEdit,
        props: { propParentFn: this.receiveQuestionFromChild, questionnaireId: this.propId },
        hasModalCard: true,
        trapFocus: true,
        canCancel: ['x']
      })
    },
    receiveQuestionFromChild (question) {
      this.questions[question.id] = question
      this.refreshQuestionsTable()
    },
    confirmRemoveQuestion (id, questionName) {
      if (this.role !== 'viewer') {
        this.$buefy.dialog.confirm({
          message: 'Do you want to <b>delete</b> question "' + questionName + '"?',
          confirmText: 'Delete',
          type: 'is-danger',
          onConfirm: () => {
            let filteredQuestions = {}
            for (let qId in this.questions) {
              if (qId !== id) {
                filteredQuestions[qId] = this.questions[qId]
              }
            }
            this.questions = filteredQuestions
            this.refreshQuestionsTable()
          }
        })
      }
    },
    editQuestionModal (id) {
      this.$buefy.modal.open({
        parent: this,
        component: QuestionAddEdit,
        props: { editEnabled: true, propQuestion: this.questions[id], propId: id, propParentFn: this.updateQuestionFromChild, questionnaireId: this.propId },
        hasModalCard: true,
        trapFocus: true,
        canCancel: ['x']
      })
    },
    updateQuestionFromChild (question, id) {
      this.questions[id] = question
      this.refreshQuestionsTable()
    },
    addQuestionnaire () {
      if (this.role !== 'viewer') {
        this.bQuestionnaireError = false
        if (this.name === '') {
          this.bQuestionnaireError = true
        } else {
          this.loadingComponent = this.$buefy.loading.open({
            container: this.$refs.element.$el
          })
          let newQuestionnaireRef = null
          if (!this.getNotMigrated().includes(this.userId)) {
            newQuestionnaireRef = this.$store.state.database.ref('/neoslide/questionnaires/' + this.workspaceId).push()
          } else {
            newQuestionnaireRef = this.$store.state.database.ref('/questionnaires/' + this.userId).push()
          }
          this.questionnaireId = newQuestionnaireRef['key']
          for (let qId in this.questions) {
            this.questions[qId].id = qId
          }
          newQuestionnaireRef.set({
            name: this.name,
            questions: this.questions
          }).then(() => {
            this.closeModal()
            this.loadingComponent.close()
          })
        }
      }
    },
    saveQuestionnaire () {
      if (this.role !== 'viewer') {
        this.bQuestionnaireError = false
        if (this.name === '') {
          this.bQuestionnaireError = true
        } else {
          this.loadingComponent = this.$buefy.loading.open({
            container: this.$refs.element.$el
          })
          let id = this.questionnaireId
          let editQuestionnaireRef = null
          if (!this.getNotMigrated().includes(this.userId)) {
            editQuestionnaireRef = this.$store.state.database.ref('/neoslide/questionnaires/' + this.workspaceId + '/' + id)
          } else {
            editQuestionnaireRef = this.$store.state.database.ref('/questionnaires/' + this.userId + '/' + id)
          }
          for (let qId in this.questions) {
            this.questions[qId].id = qId
          }
          editQuestionnaireRef.update({
            name: this.name,
            questions: this.questions
          }, () => {
            this.closeModal()
            this.loadingComponent.close()
          })
        }
      }
    },
    cancelEdit () {
      if (this.editEnabled) {
        this.name = this.editStaticQuestionnaireRef.name
        this.questions = [...this.editStaticQuestionnaireRef.questions]
      }
      this.closeModal()
    },
    closeModal () {
      if (this.propParentFn) {
        this.propParentFn()
      }
      this.$parent.close()
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/questionnaires/QuestionnaireAddEdit.vue